const LIGHT_PALETTE = [
  '#1a73e8',
  '#d93025',
  '#f9ab00',
  '#188038',
  '#9334e6',
  '#e8710a',
  '#12b5cb',
  '#c5221f',
  '#0b8043',
  '#3f51b5',
  '#e91e63',
  '#009688',
];

const DARK_PALETTE = [
  '#8ab4f8',
  '#f28b82',
  '#fdd663',
  '#81c995',
  '#c58af9',
  '#fcad70',
  '#78d9ec',
  '#f6aea9',
  '#a8dab5',
  '#9aa0f6',
  '#f48fb1',
  '#80cbc4',
];

const hashString = (value) => {
  const str = String(value || 'unknown');
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
};

export const getColorForName = (name, isDarkMode = false) => {
  const palette = isDarkMode ? DARK_PALETTE : LIGHT_PALETTE;
  const index = hashString(name) % palette.length;
  return palette[index];
};

export const resolveColorForName = (name, colorMap, isDarkMode = false) => {
  if (name && colorMap?.[name]) {
    return colorMap[name];
  }
  return getColorForName(name, isDarkMode);
};

export const buildColorMapForNames = (names, isDarkMode = false) => {
  const uniqueNames = [...new Set((names || []).filter(Boolean))].sort();
  return uniqueNames.reduce((acc, name) => {
    acc[name] = getColorForName(name, isDarkMode);
    return acc;
  }, {});
};

export const collectProfileNamesFromChartData = (dataByUser) => {
  const names = [];

  Object.values(dataByUser || {}).forEach((userData) => {
    (userData?.profiles || []).forEach((profile) => names.push(profile));
    (userData?.dates || []).forEach((day) => {
      Object.keys(day || {}).forEach((key) => {
        if (key !== 'date') {
          names.push(key);
        }
      });
    });
  });

  return names;
};
